__turbopack_context__.v({
  "count": "title-panel-module-scss-module__49M3Ma__count",
  "countInline": "title-panel-module-scss-module__49M3Ma__countInline",
  "root": "title-panel-module-scss-module__49M3Ma__root",
  "title": "title-panel-module-scss-module__49M3Ma__title",
});
